import * as React from 'react';
import { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row, Toast } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import checkmark from '../../assets/images/checkmark.png';
import logo from '../../assets/images/logo.png';
import Text from '../../components/text';
import { certificazioneContattoClienteAction, getDettaglioCertificazioneClienteAction, inviaSmsCertificazioneClienteAction } from './_redux/actions';
import { certificazioneContattoClienteSelector, dettaglioCertificazioneClienteSelector, dettaglioSmsCertificazioneClienteSelector } from './_redux/selectors';

const CertificazioneCliente: React.FC = () => {

  const dispatch = useAppDispatch();
  const dettaglioCertificazioneCliente = useAppSelector(dettaglioCertificazioneClienteSelector);
  const resultCertificazioneContattoCliente = useAppSelector(certificazioneContattoClienteSelector);
  const dettaglioSmsCertificazioneCliente = useAppSelector(dettaglioSmsCertificazioneClienteSelector);
  const [tokenCellulare, setTokenCellulare] = useState<string>('');
  const [showSuccessModal, setShowSuccessModal] = useState<boolean>(false);
  const [disableButton, setDisableButton] = useState<boolean>(false);
  const [showSMSToast, setShowSMSToast] = useState<boolean>(false);
  const [seconds, setSeconds] = useState<number>(30);

  useEffect(() => {
    dispatch(getDettaglioCertificazioneClienteAction());
  }, [dispatch]);

  useEffect(() => {
    if (dettaglioSmsCertificazioneCliente) {
      setShowSMSToast(true);
      setSeconds(30);
      setDisableButton(true);
      dispatch(getDettaglioCertificazioneClienteAction());
    }
  }, [dettaglioSmsCertificazioneCliente]);

  useEffect(() => {
    if (disableButton) {
      const interval = setInterval(() => {
        setSeconds(seconds => {
          if (seconds <= 1) {
            setDisableButton(false)
            clearInterval(interval);
          }
          return seconds - 1;
        });
      }, 1000);
    }
  }, [disableButton]);

  const inviaSmsCertificazioneCliente = () => {
    dispatch(inviaSmsCertificazioneClienteAction());
  };

  useEffect(() => {
    if (!!resultCertificazioneContattoCliente) {
      localStorage.removeItem('accessTokenCliente');
      setShowSuccessModal(true);
    }
  }, [resultCertificazioneContattoCliente]);

  const certificazioneContattoCliente = () => {
    dispatch(certificazioneContattoClienteAction(tokenCellulare))
  };


  return (
    <div>
      {!showSuccessModal ? <Container>
        <Toast delay={3000} autohide show={showSMSToast} onClose={() => setShowSMSToast(false)}
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
          }}
        >
          <Toast.Header closeButton={false}><strong>SMS inviato con successo</strong></Toast.Header>
          <Toast.Body>Controlla il tuo cellulare ed inserisci il codice ricevuto</Toast.Body>
        </Toast>
        <Row className="align-items-center">
          <Col md={2}>
            <img alt="Logo Desio" src={logo} className="logoDesio" />
          </Col>
          <Col md={10}>
            <Text title={`Ciao ${dettaglioCertificazioneCliente?.nominativo}`} type="titolo" />
            <Text title={`CONFERMA I TUOI CONTATTI BANCO DESIO`} type="sottotitolo" />
          </Col>
        </Row>
        <Row>
          <Col md={10} className="mt-2">
            <Text title="Conferma il contatto in pochi semplici passi: invia un codice OTP al tuo recapito 
             telefonico, inserisci il codice nell'apposito campo e conferma il contatto."></Text>
          </Col>
        </Row>
        <div>
          <Row className="mt-5 d-flex align-items-center">
            <Col md={2}>
            </Col>
            <Col md={1}>
              <div className="setNumber">1</div>
            </Col>
            <Col md={4}>
              <div>Invia il codice al numero {dettaglioCertificazioneCliente?.cellulareCertificazione || '???'}</div>
              {disableButton && (
                <div>
                  Puoi inviare un nuovo SMS tra {seconds} secondi
                </div>
              )}
            </Col>
            <Col md={'auto'} className="text-center mt-2">
              <Button className="button" onClick={inviaSmsCertificazioneCliente} disabled={disableButton}>
                Invia Sms <i className="fas fa-chevron-right pl-2" />
              </Button>
            </Col>

          </Row>
          <Row className="mt-5 d-flex align-items-center">
            <Col md={2}>
            </Col>
            <Col md={1}>
              <div className="setNumber">2</div>
            </Col>
            <Col md={4}>
              <div>Inserisci il codice ricevuto</div>
            </Col>
            <Col md={2}>
              <Form.Control type="text" value={tokenCellulare} onChange={e => setTokenCellulare(e.target.value)} />
            </Col>

          </Row>
          <Row className="mt-5 d-flex align-items-center">
            <Col md={2}>
            </Col>
            <Col md={1}>
              <div className="setNumber">3</div>
            </Col>
            <Col md={4}>
              <div>Conferma il contatto</div>
            </Col>
            <Col sm={12} md={4} lg={4} className="">
              <Button className="button col-md-6 col-sm-12" onClick={certificazioneContattoCliente} disabled={!tokenCellulare}>
                Conferma
              </Button>
            </Col>

          </Row>
        </div>

      </Container>
        :
        <Container>

          <div className="mt-5">
            <Row>
              <Col className="text-center">
                <Text title="Certificazione avvenuta con successo" type="titolo"></Text>
                <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                  <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
                  <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                </svg>
                <img className="checkmark-only-IE11" src={checkmark} height={56} style={{ marginTop: 24, marginBottom: 24, marginRight: 'auto', marginLeft: 'auto' }} />
              </Col>
            </Row>
          </div>
        </Container>
      }

    </div>
  );
}

export default CertificazioneCliente;



